import { db } from "@/shared/firbase";
import { collection, DocumentData, getDocs } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../Loading";
import { Body } from "./style";
import { useTranslation } from "react-i18next";
import Header from "@/components/Header/Index";

const GameSelect = () => {
  const { name } = useParams();
  const dbCollection = collection(db, String(name));
  const [data, setData] = useState<DocumentData[]>([]);
  const { t } = useTranslation();

  const getData = async () => {
    const data = await getDocs(dbCollection);
    setData(data.docs.map((doc) => doc.data()).sort(() => Math.random() - 0.5));
    return;
  };
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Header />
      <Body>
        {data.length === 0 ? (
          <Loading />
        ) : (
          <>
            <div>
              '{t(`${name}`)}' {t(`이상형 월드컵!`)}
            </div>
            <div> {t(`몇강부터 시작할까요?`)}</div>
            <div className="buttonFlex">
              {data?.length > 15 && (
                <button onClick={() => navigate(`/game/${name}/16`)}>
                  <span>{t(`16강`)}</span>
                </button>
              )}
              {data?.length > 31 && (
                <button onClick={() => navigate(`/game/${name}/32`)}>
                  <span>{t(`32강`)}</span>
                </button>
              )}
              {data?.length > 63 && (
                <button onClick={() => navigate(`/game/${name}/64`)}>
                  <span>{t(`64강`)}</span>
                </button>
              )}
            </div>
          </>
        )}
      </Body>
    </>
  );
};

export default GameSelect;
